import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepCoupon extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Coupon: Resource Representations</h1>
				<h2>Coupon</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> coupon_id </td>
							<td> Integer </td>
							<td> Used to uniquely identify the coupon in your  </td>
							<td> </td>
						</tr>
						<tr>
							<td> date_issued </td>
							<td> Timestamp </td>
							<td> Timestamp indicating when this coupon is created </td>
							<td> </td>
						</tr>
						<tr>
							<td> date_expire </td>
							<td> Timestamp </td>
							<td> Time until the coupon can be applied to  </td>
							<td> </td>
						</tr>
						<tr>
							<td> seller_name </td>
							<td> String </td>
							<td> The username of the seller in BL </td>
							<td> </td>
						</tr>
						<tr>
							<td> buyer_name </td>
							<td> String </td>
							<td> The username of the buyer in BL </td>
							<td> </td>
						</tr>
						<tr>
							<td> store_name </td>
							<td> String </td>
							<td> The store name displayed on BL store pages </td>
							<td> </td>
						</tr>
						<tr>
							<td> status </td>
							<td> String </td>
							<td> Status of the coupon. Possible values are:<br/>- O: Open<br/>- A: Redeemed<br/>- D: Declined <br/>- E: Expired </td>
							<td> </td>
						</tr>
						<tr>
							<td> remarks </td>
							<td> String </td>
							<td> A description of the coupon that can be displayed to buyers </td>
							<td> </td>
						</tr>
						<tr>
							<td> order_id </td>
							<td> Integer </td>
							<td> Order ID associated with this coupon </td>
							<td> </td>
						</tr>
						<tr>
							<td> currency_code </td>
							<td> String </td>
							<td> The three letter code for the currency used for the transaction </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a> </td>
						</tr>
						<tr>
							<td> disp_currency_code </td>
							<td> String </td>
							<td> The three letter code for the currency used for displaying the price </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a> </td>
						</tr>
						<tr>
							<td> discount_type </td>
							<td> String </td>
							<td> The type of discount. Possible values are:<br/>- F: Fixed amount coupon. The discount is expressed as a discrete monetary value<br/>- S: Percentage coupon. The discount is expressed as a percentage </td>
							<td> </td>
						</tr>
						<tr>
							<td> applies_to </td>
							<td> Object </td>
							<td> This object provides ability to restrict a PERCENTAGE coupon to a specific item type or condition </td>
							<td> </td>
						</tr>
						<tr>
							<td> applies_to.type </td>
							<td> String </td>
							<td>  The type of restriction. Possible values are:<br/>- A: Discount will be applied to the total of all items in an order which are a specified item type (or all items regardless of the type if applies_to.item_type is not specified)<br/>- E: Discount will be applied to the total of all items in an order which are all except a specified item type </td>
							<td> </td>
						</tr>
						<tr>
							<td> applies_to.item_type </td>
							<td> String </td>
							<td> The type of items for which this discounts need to be applied ( or excluded ) </td>
							<td> </td>
						</tr>
						<tr>
							<td> applies_to.except_on_sale </td>
							<td> Boolean </td>
							<td> Indicates that whether the discount of the coupon to exclude items on sale </td>
							<td> </td>
						</tr>
						<tr>
							<td> discount_amount </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_discount_amount </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> discount_rate </td>
							<td> Integer </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> max_discount_amount </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_max_discount_amount </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> tier_price1 </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_tier_price1 </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> tier_discount_rate1 </td>
							<td> Integer </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> tier_price2 </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_tier_price2 </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> tier_discount_rate2 </td>
							<td> Integer </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> tier_price3 </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_tier_price3 </td>
							<td> Decimal </td>
							<td> </td>
							<td> </td>
						</tr>
						<tr>
							<td> tier_discount_rate3 </td>
							<td> Integer </td>
							<td> </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
			</section>
		);
	}
}